import React, {useContext} from 'react'
import styled, {keyframes} from 'styled-components'

import {StateContext} from '../../utils/context'

import TopBtn from '../../atoms/TopBtn'

const list = [
  {
    url: '/about',
    title: 'ABOUT',
  },
  {
    url: '/blogs',
    title: 'BLOGS',
  },
  // {
  //   url: '/projects',
  //   title: 'PROJECTS',
  // },
  {
    url: '/contact',
    title: 'CONTACT',
  },
]

export default ({isTop}) => {
  const {state} = useContext(StateContext)
  return (
    <FuncContainer className={state.isHeaderMenuActive ? 'active' : null}>
      <PageList active={state.isHeaderMenuActive}>
        {state.isMobile ? (
          <PageItem sec="0.3">
            <TopBtn to="/" title="HOME" isTop={isTop}/>
          </PageItem>
        ) : null}
        {list.map((item, index) => {
          return (
            <PageItem key={item.url} sec={0.3 * (index + 1)}>
              <TopBtn to={`${item.url}`} title={`${item.title}`} isTop={isTop}/>
            </PageItem>
          )
        })}
      </PageList>
    </FuncContainer>
  )
}

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-60px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`
const FuncContainer = styled.div`
  visibility: hidden;
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: ${props => props.theme.darkBeige};
  transition: all 0.2s;
  &.active {
    display: flex;
    visibility: visible;
    opacity: 1;
  }
  @media(min-width: 900px) {
    display: flex;
    visibility: visible;
    opacity: 1;
    background-color: transparent;
    margin: 0;
    padding: 0;
    position: initial;
    width: auto;
    height: 100%;
    justify-content: inherit;
  }
`
const PageList = styled.ul`
  display: ${props => props.active ? 'flex': 'none'};
  width: 90%;
  margin: 0 auto;
  flex-direction: column;
  padding-top: 7rem;
  @media(min-width: 900px) {
    display: flex;
    flex-direction: row;
    padding: 0;
    margin: 0;
  }
`
const PageItem = styled.li`
  list-style: none;
  width: 90%;
  height: 5rem;
  margin: 1rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} ease ${props => props.sec}s;
  @media(min-width: 900px) {
    display: flex;
    flex-direction: row;
    padding: 0;
    height: 100%;
    margin: 0 auto;
  }
`